import React, { useEffect, useState } from 'react'
import {
    Button,
    Col,
    Drawer,
    Form,
    Input,
    message,
    Row,
    Select,
    Space
} from 'antd';
import { post } from 'util/http';
import module from 'util/module';
import MetaFormItem from 'component/MetaFormItem'

const Page = ({
    param,
    setParam,
    reload
}) => {


    const metaCode = "paifuFactory"

    const [pageForm] = Form.useForm();
    var typeName = null;

    const [meta, setMeta] = useState({
        attrs: []
    });


    useEffect(() => {
        post(module.app + '/meta/v1.0/get-by-code', { code: metaCode })
            .then(res => {
                setMeta(res.data);
            })
    }, [])
    useEffect(() => {
        if (param.visible) {
            if (param.id != '') {
                post(module.app + '/meta/v1.0/data/get', {
                    id: param.id,
                    metaCode: metaCode
                }).then(res => {
                    pageForm.setFieldsValue({
                        ...res.data
                    });
                })
            } else {
                pageForm.resetFields();
            }
        }


    }, [param])

    return (<Drawer title="创建厂家"
        placement="right"
        width={960}
        maskClosable={false}
        onClose={() => {
            setParam({ ...param, visible: false })
        }}
        visible={param.visible}
        extra={
            <Space>
                <Button onClick={() => {
                    setParam({ ...param, visible: false })
                }}>取消</Button>
                <Button type="primary" onClick={() => {
                    pageForm.validateFields().then((data) => {
                        const url = module.app + '/meta/v1.0/data/save';
                        post(url, {
                            metaCode: metaCode,
                            datas: data
                        }).then(res => {
                            setParam({ ...param, visible: false });
                            reload();
                            message.info("保存成功");
                        })
                    })
                }}>
                    确认
                </Button>
            </Space>
        }
    >
        <Form form={pageForm} layout="horizontal" hideRequiredMark
            labelCol={{
                style: { width: 80 }
            }}
            initialValues={{
                attrs: []
            }}
        >
            <Form.Item style={{ display: 'none' }}
                name="id">
                <Input type="hidden" />
            </Form.Item>
            <Form.Item name='regionName' style={{ display: 'none' }} >
                <Input type={"hidden"} />
            </Form.Item>
            <Form.Item name='fullRegionName' style={{ display: 'none' }} >
                <Input type={"hidden"} />
            </Form.Item>
            <Form.Item name='fullRegionCode' style={{ display: 'none' }} >
                <Input type={"hidden"} />
            </Form.Item>
            {meta.attrs.map((item) => {
                return item.isSystem == 2 &&
                    (
                        <Form.Item
                            name={item.attrCode}
                            label={item.attrName}
                            key={item.attrCode}
                            rules={[{ required: item.isRequired == 1, message: '请输入' + item.attrName }]}
                        >
                            <MetaFormItem
                                pageForm={pageForm}
                                metaAttr={item}
                                onChange={(_, v, extra) => {
                                    if (item.attrCode == 'regionCode') {
                                        pageForm.setFieldsValue({
                                            ...{
                                                regionName: extra.triggerNode.props.data.name,
                                                fullRegionName: extra.triggerNode.props.data.fullNames,
                                                fullRegionCode: extra.triggerNode.props.data.fullCodes
                                            }
                                        })
                                    }
                                }}
                            />
                        </Form.Item>
                    )
            })}
        </Form>
    </Drawer>)
}

export default Page;